<template>
    <div id="footer">
        <div class="footer-container">
            <div class="header-section text-start mb-4">
                <img class="footer-logo mb-2" src="./../assets/images/logo_2.png" alt="OMNI COUNSEL">
                <div class="company-info">
                    <h6 class="fw-bold brand-purple mb-0">DELICAT Pte. Ltd</h6>
                    <a class="brand-purple text-decoration-none email-link" href="mailto:info@omni-counsel.com">
                        info@omni-counsel.com
                    </a>
                </div>
            </div>

            <hr class="divider">

            <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 locations-grid text-start">
                <div class="col mb-4">
                    <div class="location-badge">Singapore</div>
                    <p class="address-text">
                        60 PAYA LEBAR ROAD, #05-07<br>
                        PAYA LEBAR SQUARE, SINGAPORE 409051
                    </p>
                </div>
                <div class="col mb-4">
                    <div class="location-badge">Taiwan</div>
                    <p class="address-text">
                        No. 110, Sec. 2, Tailin Road<br>
                        Taishan District, New Taipei City 243
                    </p>
                </div>
                <div class="col mb-4">
                    <div class="location-badge">Japan</div>
                    <p class="address-text">
                        1-13-3 Wakabayashi<br>
                        Setagaya-ku, Tokyo Japan 154-0023
                    </p>
                </div>
                <div class="col mb-4">
                    <div class="location-badge">China</div>
                    <p class="address-text">
                        Room 1049, 1/F, Building 10<br>
                        No. 19, Lane 1698, Wangyuan Road<br>
                        Fengxian District, Shanghai
                    </p>
                </div>
            </div>

            <div class="footer-bottom border-top pt-4 mt-2">
                <p class="copyright-text brand-purple text-center w-100">
                    Copyright © 2026 OMNI COUNSEL All rights reserved
                </p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/scss/theme.scss';

// 定義指定色
$omni-purple: #601D7F;

#footer {
    background-color: #ffffff;
    width: 100%;
    padding: 50px 20px;
    display: flex;
    justify-content: center;

    .footer-container {
        width: 100%;
        max-width: 800px; 
        margin: 0 auto;
    }

    .footer-logo {
        max-width: 150px;
        height: auto;
        display: block;
    }

    .brand-purple {
        color: $omni-purple !important;
    }

    .email-link {
        font-size: 0.85rem;
        &:hover {
            text-decoration: underline !important;
        }
    }

    .divider {
        border: 0;
        border-top: 1px solid $omni-purple;
        opacity: 0.3;
        margin: 25px 0;
    }

    .location-badge {
        display: inline-block;
        background-color: $omni-purple; 
        color: #ffffff;
        padding: 4px 18px;
        border-radius: 20px;
        font-size: 0.8rem;
        font-weight: 500;
        margin-bottom: 12px;
        min-width: 90px;
        text-align: center;
    }

    .address-text {
        font-size: 0.75rem;
        color: #000000; 
        line-height: 1.5;
        margin-bottom: 0;
        word-break: break-word;
    }

    .copyright-text {
        font-size: 0.8rem;
        font-weight: 400;
        letter-spacing: 0.5px;
        margin-bottom: 0;
    }
}

// 響應式調整
@media (max-width: 991px) {
    .location-badge {
        min-width: 80px;
    }
}
</style>